import { resolveUserRoute } from "./routes.ts"

export const consumerTabPaths = ["/home", "/shop", "/my"] as const

export const isConsumerTabPath = (pathname: string): boolean => consumerTabPaths.some((path) => path === pathname)

export const isConsumerAppPath = (pathname: string): boolean => pathname !== "/login" && pathname !== "/entry" && !pathname.startsWith("/transfer/") && !pathname.startsWith("/onboarding/") && resolveUserRoute(pathname) !== null

/** The persistent tab host owns these views; Next synchronizes its hooks with native history. */
export const replaceConsumerTab = (href: string): boolean => {
  if (typeof window === "undefined" || !isConsumerAppPath(window.location.pathname)) return false
  const target = new URL(href, window.location.href)
  if (target.origin !== window.location.origin || !isConsumerTabPath(target.pathname)) return false
  if (target.href === window.location.href) return true
  window.dispatchEvent(new Event("cashhub:navigation-start"))
  // Do not copy history.state: Next's internal marker would bypass hook synchronization.
  window.history.replaceState(null, "", `${target.pathname}${target.search}${target.hash}`)
  return true
}
